// Copyright (c) 2018 Deere & Company

import {
    addInfoRequestFormFile,
    deleteInfoRequestFormFile,
    updateInfoRequestFormAnswer,
    updateInfoRequestFormComments,
    updateInfoRequestFormReturnStatus
} from './information-request-form';
import {
    addPictRequestFormFile,
    deletePictRequestFormFile,
    updatePictRequestFormComments,
    updatePictRequestFormReturnStatus
} from './picture-request-form';
import {
    resetRequestDetails,
    setFormToPrestine
} from './reset-request-details';
import {
    updatePartRequestFormComments,
    updatePartRequestFormCourierName,
    updatePartRequestFormDispatchDate,
    updatePartRequestFormReturnStatus,
    updatePartRequestFormTrackingNumber
} from './part-request-form';
import {goToPreviousView} from '../../../shared/action-creators/go-to-previous-view';
import {readRequestDetails} from './get-request-details';
import {submitRequestForm} from './submit-request-form';

export default {
    addInfoRequestFormFile,
    addPictRequestFormFile,
    deleteInfoRequestFormFile,
    deletePictRequestFormFile,
    goToPreviousView,
    readRequestDetails,
    resetRequestDetails,
    setFormToPrestine,
    submitRequestForm,
    updateInfoRequestFormAnswer,
    updateInfoRequestFormComments,
    updateInfoRequestFormReturnStatus,
    updatePartRequestFormComments,
    updatePartRequestFormCourierName,
    updatePartRequestFormDispatchDate,
    updatePartRequestFormReturnStatus,
    updatePartRequestFormTrackingNumber,
    updatePictRequestFormComments,
    updatePictRequestFormReturnStatus
};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/index.js